class Extract {
    constructor() {
        this.data = function (response) {
            var _a;
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.data) {
                return {
                    data: response.data.data,
                    error: undefined,
                    status: 'ok'
                };
            }
            return {
                data: response.data,
                error: undefined,
                status: 'ok'
            };
        };
        this.error = function (error) {
            var _a, _b, _c;
            return {
                data: null,
                error: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.description) !== null && _c !== void 0 ? _c : error.message,
                status: 'error'
            };
        };
    }
}
export default new Extract();
//# sourceMappingURL=extract.js.map